module.exports = __webpack_public_path__ + "static/media/pendingCredit.ab4e3572.png";